import React, { useState } from "react";
import "../../css/footer.scss";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { localizeEuroAmountsInString } from "../../constans/CurrencyConstants";
import { useSiteSettings } from "./SiteSettingsContext";
import { languageFlagSrc, languageLabelKey } from "../../utils/languageDisplay";
import { instagram, tiktok, telegram, whatsapp } from "../../constans/ColorConstants";

const Footer = () => {
  const { t, i18n: i18nInstance } = useTranslation();
  const { openSettings, settingsModalOpen } = useSiteSettings();
  const toTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  const lang = i18nInstance.language || "nl";
  const [promoOpen, setPromoOpen] = useState(true);

  return (
    <>
      <footer
        className={`footer${promoOpen ? " footer--withPromoBar" : ""}`}
        role="contentinfo"
        aria-label="Site footer"
      >
        <div className="footer__container">
          <div className="footer__grid">
            <div className="footer__col">
              <h4 className="footer__title">{t("footer.information")}</h4>
              <ul className="footer__list">
                <li>
                  <Link
                    onClick={toTop}
                    className="footer__link"
                    to="/calculator"
                  >
                    {t("footer.links.calculator")}
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} className="footer__link" to="/help">
                    {t("footer.links.help")}
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} className="footer__link" to="/terms">
                    {t("footer.links.terms")}
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} className="footer__link" to="/refund">
                    {t("footer.links.refund")}
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} className="footer__link" to="/shipping">
                    {t("footer.links.shipping")}
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} className="footer__link" to="/privacy">
                    {t("footer.links.privacy")}
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} className="footer__link" to="/contact">
                    {t("footer.links.contact")}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__title">{t("footer.bestSellers")}</h4>
              <ul className="footer__list">
                <li>
                  <Link
                    onClick={toTop}
                    className="footer__link"
                    to="/shopDetails/reta_23"
                  >
                    Reta
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={toTop}
                    className="footer__link"
                    to="/shopDetails/GHK-CU_24"
                  >
                    GHK-CU
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={toTop}
                    className="footer__link"
                    to="/shopDetails/melanotan-ii_25"
                  >
                    Melanotan-II
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={toTop}
                    className="footer__link"
                    to="/shopDetails/glow70_blend_37"
                  >
                    GLOW70 Blend
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={toTop}
                    className="footer__link"
                    to="/shopDetails/nad_32"
                  >
                    NAD+
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={toTop}
                    className="footer__link"
                    to="/shopDetails/Tesamorelin_71"
                  >
                    Tesamorelin
                  </Link>
                </li>
                <li>
                  <Link
                    onClick={toTop}
                    className="footer__link"
                    to="/shopDetails/BPC-157_31"
                  >
                    BPC-157
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <h4 className="footer__title">{t("footer.cooperation")}</h4>
              <ul className="footer__list">
                <li>
                  <Link onClick={toTop} className="footer__link" to="/bulk">
                    {t("footer.links.bulk")}
                  </Link>
                </li>
                <li>
                  <Link onClick={toTop} className="footer__link" to="/partner">
                    {t("footer.links.partner")}
                  </Link>
                </li>
              </ul>
            </div>

            <div className="footer__col">
              <div className="footer__socialRow">
                <h4 className="footer__title">{t("footer.ourSocials")}</h4>
                <div className="footer__socials">
                  <Link
                    className="social-btn"
                    to={tiktok}
                    aria-label="TikTok"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      t="1773223372060"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="7961"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M937.4 423.9c-84 0-165.7-27.3-232.9-77.8v352.3c0 179.9-138.6 325.6-309.6 325.6S85.3 878.3 85.3 698.4c0-179.9 138.6-325.6 309.6-325.6 17.1 0 33.7 1.5 49.9 4.3v186.6c-15.5-6.1-32-9.2-48.6-9.2-76.3 0-138.2 65-138.2 145.3 0 80.2 61.9 145.3 138.2 145.3 76.2 0 138.1-65.1 138.1-145.3V0H707c0 134.5 103.7 243.5 231.6 243.5v180.3l-1.2 0.1"
                        p-id="7962"
                        fill="#1a1a1a"
                      ></path>
                    </svg>
                  </Link>
                  <Link
                    className="social-btn"
                    to={instagram}
                    aria-label="Instagram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      t="1773223402388"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="9008"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9z m0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zM725.5 250.7c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9c-0.1-26.6-21.4-47.9-47.9-47.9z"
                        p-id="9009"
                        fill="#1a1a1a"
                      ></path>
                      <path
                        d="M911.8 512c0-55.2 0.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-0.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-0.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9 0.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165z m-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z"
                        p-id="9010"
                        fill="#1a1a1a"
                      ></path>
                    </svg>
                  </Link>
                  <Link
                    onClick={toTop}
                    className="social-btn"
                    to={telegram}
                    aria-label="Telegram"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      t="1773223437145"
                      class="icon"
                      viewBox="0 0 1024 1024"
                      version="1.1"
                      xmlns="http://www.w3.org/2000/svg"
                      p-id="10058"
                      width="200"
                      height="200"
                    >
                      <path
                        d="M679.424 746.861714l84.004571-395.995428c7.424-34.852571-12.580571-48.566857-35.437714-40.009143l-493.714286 190.281143c-33.718857 13.129143-33.133714 32-5.705142 40.557714l126.281142 39.424 293.156572-184.576c13.714286-9.142857 26.294857-3.986286 16.018286 5.156571l-237.129143 214.272-9.142857 130.304c13.129143 0 18.870857-5.705143 25.709714-12.580571l61.696-59.428571 128 94.281142c23.442286 13.129143 40.009143 6.290286 46.299428-21.723428zM1024 512c0 282.843429-229.156571 512-512 512S0 794.843429 0 512 229.156571 0 512 0s512 229.156571 512 512z"
                        fill="#1a1a1a"
                        p-id="10059"
                      ></path>
                    </svg>
                  </Link>
                  <Link
                    onClick={toTop}
                    className="social-btn"
                    to={whatsapp}
                    aria-label="WhatsApp"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="200"
                      height="200"
                      fill="#1a1a1a"
                    >
                      <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413z" />
                    </svg>
                  </Link>
                </div>
              </div>

              <div className="footer__language">
                <div className="lang-dropdown">
                  <button
                    type="button"
                    className="lang-toggle"
                    onClick={openSettings}
                    aria-haspopup="dialog"
                    aria-expanded={settingsModalOpen}
                    aria-controls="entry-gate-title"
                  >
                    <img
                      alt=""
                      src={languageFlagSrc(lang)}
                      className="lang-flag"
                    />
                    <span className="lang-text">
                      {t(languageLabelKey(lang))}
                    </span>
                    <img className="chevron" alt="" src="/head/arrow1.svg" />
                  </button>
                </div>
              </div>
            </div>
          </div>

          <div className="payment-icons">
            <img alt="" src="/head/foot1.avif" />
            <div className="footer__copyright">© 2025 Puritybase</div>
          </div>
        </div>
      </footer>
      {promoOpen && (
        <div
          className="footer__promoBar"
          role="region"
          aria-label="Free shipping notice"
        >
          <span className="promoBar__text">
            {localizeEuroAmountsInString(
              t("footer.promoFreeShip"),
              i18nInstance.language
            )}
          </span>
          <button
            className="promoBar__close"
            aria-label="Sluiten"
            onClick={() => setPromoOpen(false)}
          >
            ×
          </button>
        </div>
      )}
    </>
  );
};

export default Footer;
